import React from "react";
import { classNames } from "@/utils/utils";

import styles from "./UserButtonMessage.module.css";

type Props = {
  className?: string;
  disabled?: boolean;
  children?: React.ReactNode;
  onClick?: () => void;
};

export const UserButtonMessage: React.FC<Props> = ({
  className,
  disabled,
  onClick,
  children,
}) => {
  return (
    <div className={styles.container}>
      <button
        disabled={disabled}
        onClick={onClick}
        className={classNames(styles.bubble, className)}
      >
        {children}
      </button>
    </div>
  );
};
